import { useContext } from "react";
import { ErrorDialogContext, errorHandledAsync } from "@/shared/context/error-context";
import { GetUsersIntegrationService } from "@/features/user/services/get-integration-service";
import { useValidators } from "@/shared/utils/validate";


export const useGetUsersIntegration = () => {
  const getUsersIntegrationService = new GetUsersIntegrationService();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const { passwordValidator } = useValidators();

  const getUsersIntegration = async (
    ownerId: string,
    password: string
  ) => {
    try {
      // 入力チェック
      const passwordErrorMessage = passwordValidator(password);
      if (passwordErrorMessage) {
        return { errorMessage: passwordErrorMessage };
      }
      const res = await getUsersIntegrationService.getUsersIntegration({
        owner_id: ownerId,
        owner_pw: password
      });
      const passbooks = res.map((item) => item.passbook_name);
      return passbooks;
    } catch (error) {
      // エラー
      console.log("getUsersIntegration", error);
      throw error; 
    } finally {
      //
    }
  };

  return {
    getUsersIntegration: errorHandledAsync(getUsersIntegration, setError),
  };
};
